import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicSite from "./pages/PublicSite";
import PhotosPage from "./pages/PhotosPage";
import InfoPage from "./pages/InfoPage";
import ContactPage from "./pages/ContactPage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";
import MobileForm from "./pages/MobileForm";
import VisitorTracker from "./components/VisitorTracker";
import CookieConsent from "./components/CookieConsent";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <VisitorTracker />
        <CookieConsent />
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/photos" element={<PhotosPage />} />
          <Route path="/info" element={<InfoPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/mobile" element={<MobileForm />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
